module.exports = __webpack_public_path__ + "static/img/baccarat-guide-01.0b39fbf.png";